import React from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getValueFromResource } from '../../common/timeLiveFunction';

const TimesheetMoreOptionWidget = () => {
    const { accountEmployeeTimeEntryPeriodId, accountEmployeeId, decimalTotalHours, showTemplateInTimesheet, isLocked } = useAppSelector((state) => state.timesheet);
    const { showClientInTimesheet } = useAppSelector((state) => state.globalState);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const callTimesheetPeriodList = () => {
        navigate('/timesheetperiodlist')
    }

    const handleAudit = () => {
        const obj = {
            Id: accountEmployeeTimeEntryPeriodId,
            TableName: 'AccountEmployeeTimeEntryPeriod',
            Title: 'Timesheet Audit'
        }
        navigate(`/timesheetaudit/${accountEmployeeTimeEntryPeriodId}`, { state: { obj } });
    }

    const callTimesheetTemplateList = () => {
        localStorage.setItem("showClientInTimesheet", showClientInTimesheet.toString());
        navigate('/timesheettemplate', { state: { accountEmployeeId } })
    }

    return (
        <div className={"col-md-12 col-sm-12 col-xs-12"}>
            <div className="menu-item me-lg-1">
                <a className="menu-link py-3" onClick={() => { callTimesheetPeriodList() }}>
                    <span className="menu-icon">
                        <i className="bi bi-card-list fs-2">
                            <span className="path1"></span>
                            <span className="path2"></span>
                        </i>
                    </span>
                    <span className="menu-title">
                        {/* {t('Timesheet Periods')} */}
                        {getValueFromResource('Timesheet Periods',dispatch, t)}
                    </span>
                </a>
            </div>
            {decimalTotalHours > 0 && <div className="menu-item me-lg-1">
                <a className="menu-link py-3"
                    onClick={() => handleAudit()}
                >
                    <span className="menu-icon">
                        <i className="bi bi-receipt fs-2">
                            <span className="path1"></span>
                            <span className="path2"></span>
                        </i>
                    </span>
                    <span className="menu-title"> 
                        {/* {t('Timesheet Audit')} */}
                        {getValueFromResource('Timesheet Audit',dispatch, t)}
                        </span>
                </a>
            </div>}
            {showTemplateInTimesheet && !isLocked && <div className="menu-item me-lg-1">
                <a className="menu-link py-3"
                    onClick={() => callTimesheetTemplateList()}
                >
                    <span className="menu-icon">
                        <i className="bi bi-receipt fs-2">
                            <span className="path1"></span>
                            <span className="path2"></span>
                        </i>
                    </span>
                    <span className="menu-title"> 
                        {/* {t('Timesheet Template')} */}
                        {getValueFromResource('Timesheet Template',dispatch, t)}
                    </span>
                </a>
            </div>}
        </div>
    )
}

export default TimesheetMoreOptionWidget